import React, {useEffect, useState} from "react";
import {Box, Checkbox, Popper,} from "@mui/material";
import CommonColorUtils from "../../../utils/common_colors";
import {FullButton} from "../../../components/button/common_button";
import StringUtils from "../../../utils/string_utils";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import No_Record_Found_Page from "../task_allocation/no_record_found_page";
import RadioButtonWithLabel from "../../../components/radio_button_with_label";


const FmFilterDataComponent = ({
                                   open,
                                   setIsFilterOpen,
                                   anchorEl,
                                   setSelectedFilterCount,
                                   options,
                                   labels,
                                   handleClearAll,
                                   handleSubmit,
                                   initialSelectedFilters,
                                   selectedDateLabel,
                                   selectedDateRange,
                                   selectedSpecificDate,
                               }) => {


    const [selectedLabel, setSelectedLabel] = useState("Vendor Location");
    const [searchText, setSearchText] = useState("");
    const [data, setData] = useState([]);
    const [dateSelection, setDateSelection] = useState(StringUtils.dateRange);
    const [dateRange, setDateRange] = useState({start: null, end: null});
    const [specificDate, setSpecificDate] = useState(null);
    const [selectedItems, setSelectedItems] = useState(new Map());


    useEffect(() => {
        setSelectedLabel("Vendor Location")
        setSearchText("");
        setSelectedItems(new Map(initialSelectedFilters));
        setDateSelection(selectedDateLabel);
        setDateRange(selectedDateRange);
        setSpecificDate(selectedSpecificDate)
    }, [open, initialSelectedFilters])

    useEffect(() => {
        const fetchData = async () => {
            if (options && options[selectedLabel]) {
                const dataWithoutEmptyString = (options[selectedLabel] || []).filter((data) => data.trim() !== "")
                setData(dataWithoutEmptyString);
            } else {
                setData([]);
            }

        };
        fetchData();

    }, [selectedLabel, options]);

    const handleCheckboxChange = (option) => {
        setSelectedItems((prev) => {
            const updatedMap = new Map(prev); // Create a copy of the existing Map

            // Get the current options for the selected label
            const currentOptions = updatedMap.get(selectedLabel) || [];

            // Determine whether to add or remove the option
            const updatedOptions = currentOptions.includes(option)
                ? currentOptions.filter((opt) => opt !== option) // Remove if already selected
                : [...currentOptions, option]; // Add if not selected

            // If updatedOptions is empty, remove the selectedLabel key
            if (updatedOptions.length === 0) {
                updatedMap.delete(selectedLabel); // Remove the selectedLabel from the Map
            } else {
                updatedMap.set(selectedLabel, updatedOptions); // Update the Map with the new options
            }
            return updatedMap; // Return the updated Map
        });
    };


    const handleRangeDateSelection = (value) => {
        if (Array.isArray(value)) {
            setDateRange({start: value[0], end: value[1]});
        }
    };

    const handleSingleDateClick = (date) => {
        if (dateSelection === "Date Range") {
            // Reset the range and set the clicked date as the start
            setDateRange({start: date, end: null});
        } else {
            // Handle specific date selection
            setSpecificDate(date);
        }
    };


    const tileClassName = ({date, view}) => {
        if (view === "month") {
            if (dateSelection === "Date Range" && date >= dateRange.start && date <= dateRange.end) {
                return "highlight-range";
            }
            if (specificDate && date.toDateString() === specificDate.toDateString()) {
                return "highlight-start";
            }
        }
        return null;
    };

    const handleFilterSubmit = () => {
        setIsFilterOpen(false)
        if ((dateSelection === "Date Range" && dateRange.start && dateRange.end) || (dateSelection !== "Date Range" && specificDate)) {
            let filterCount = selectedItems.size + 1;
            setSelectedFilterCount(filterCount);
        } else {
            setSelectedFilterCount(selectedItems.size);
        }
        handleSubmit(selectedItems, {dateSelection: dateSelection, dateRange: dateRange, specificDate: specificDate});
    }
    return (<Popper open={open} anchorEl={anchorEl} style={{zIndex: 1300}} >
        {({TransitionProps}) => (<div {...TransitionProps}>
            <Box
                sx={{bgcolor: "background.paper"}}
            >

                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        border: "1px solid #ccc",
                        borderRadius: "8px",
                        width: "600px",
                        height: selectedLabel === "Created on" ? "450px" : "400px", // Set a fixed height for consistency
                        maxHeight: "500px",
                        padding: "10px",
                        boxShadow: "none",
                    }}
                >
                    {/* Top Section: Labels and Content */}
                    <div style={{display: "flex", flex: 1, overflowY: "auto"}}>
                        {/* Labels Section */}
                        <div style={{flex: "1", borderRight: "1px solid #ccc", padding: "10px", paddingLeft: "0px"}}>
                            {labels.map((label) => (<div
                                key={label}
                                onClick={() => {
                                    setSearchText("");
                                    setSelectedLabel(label);
                                }}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    color: selectedLabel === label ? "blue" : "black",
                                    backgroundColor: selectedLabel === label ? CommonColorUtils.selectedFilterLabelBackgroundColor : "white",
                                    width: "150px",
                                    padding: "10px",
                                    gap: "5px",
                                }}
                            >
                                {/* Dot for all selected items except "Created on" */}
                                {label !== "Created on" && selectedItems.has(label) && (
                                    <div
                                        style={{
                                            marginLeft: "-5px",
                                            borderRadius: "50%",
                                            height: "5px",
                                            width: "5px",
                                            backgroundColor: CommonColorUtils.primaryMainBlue,
                                        }}
                                    />
                                )}

                                {/* Separate dot logic for "Created on" */}
                                {label === "Created on" &&
                                    ((dateSelection === "Date Range" && dateRange.start && dateRange.end) ||
                                        (dateSelection !== "Date Range" && specificDate)) && (
                                        <div
                                            style={{
                                                marginLeft: "-5px",
                                                borderRadius: "50%",
                                                height: "5px",
                                                width: "5px",
                                                backgroundColor: CommonColorUtils.primaryMainBlue,
                                            }}
                                        />
                                    )}
                                {label}
                            </div>))}
                        </div>
                        <div style={{flex: "2", padding: "10px"}}>
                            {
                                selectedLabel === "Created on" ? (
                                        <div>
                                            <div style={{
                                                marginBottom: "10px",
                                                display: "flex",
                                                alignItems: "start",
                                                justifyContent: "start",
                                                alignContent: "center",
                                                gap: "50px",
                                            }}>

                                                <RadioButtonWithLabel
                                                    radioButtonValue={StringUtils.dateRange}
                                                    isChecked={dateSelection === StringUtils.dateRange}
                                                    label={StringUtils.dateRange}
                                                    selectedLabel={dateSelection}
                                                    handleOnChange={(e) => {
                                                        setSpecificDate(null);
                                                        setDateSelection(e.target.value)
                                                    }}
                                                />
                                                <RadioButtonWithLabel
                                                    radioButtonValue={StringUtils.specificDate}
                                                    isChecked={dateSelection === StringUtils.specificDate}
                                                    label={StringUtils.specificDate}
                                                    selectedLabel={dateSelection}
                                                    handleOnChange={(e) => {
                                                        setSpecificDate(null);
                                                        setDateRange({start: null, end: null})
                                                        setDateSelection(e.target.value)
                                                    }}
                                                />
                                            </div>
                                            <RadioButtonWithLabel
                                                radioButtonValue={StringUtils.uptoDate}
                                                isChecked={dateSelection === StringUtils.uptoDate}
                                                label={StringUtils.uptoDate}
                                                selectedLabel={dateSelection}
                                                handleOnChange={(e) => {
                                                    setSpecificDate(null);
                                                    setDateRange({start: null, end: null})
                                                    setDateSelection(e.target.value)
                                                }}
                                            />
                                            <div style={{maxHeight: "290px", overflowY: "auto", marginTop: "10px",}}>

                                                <Calendar
                                                    onChange={handleRangeDateSelection}
                                                    onClickDay={handleSingleDateClick}
                                                    selectRange={dateSelection === StringUtils.dateRange}
                                                    value={
                                                        dateSelection === StringUtils.dateRange ? [dateRange.start, dateRange.end] : specificDate
                                                    }

                                                    tileClassName={tileClassName}
                                                />
                                            </div>
                                        </div>) :

                                    (<div>
                                        {/* Search Field */}
                                        <input
                                            type="text"
                                            placeholder="Search..."
                                            value={searchText}
                                            onChange={(e) => setSearchText(e.target.value)}
                                            style={{
                                                width: "95%",
                                                height: "30px",
                                                marginBottom: "10px",
                                                padding: "8px",
                                                border: "1px solid #ccc",
                                                borderRadius: "8px",
                                            }}
                                        />
                                        <div style={{maxHeight: "250px", overflowY: "auto"}}>
                                            {/* eslint-disable-next-line react/jsx-pascal-case */}
                                            {data.filter((item) => item.toLowerCase().includes(searchText.toLowerCase())).length === 0 ? (<No_Record_Found_Page height={"250px"}/>) : data
                                                .filter((item) => item.toLowerCase().includes(searchText.toLowerCase()))
                                                .map((item) => (<div key={item}>
                                                    <Checkbox
                                                        checked={selectedItems?.get(selectedLabel)?.includes(item) || false}
                                                        onChange={() => handleCheckboxChange(item)}
                                                    />
                                                    <span style={{marginLeft: "5px"}}>{item}</span>
                                                </div>))}

                                        </div>
                                    </div>)}
                        </div>
                    </div>

                    {/* Bottom Section: Buttons */}
                    <div
                        style={{
                            display: "flex",
                            padding: "10px",
                            borderTop: "1px solid #ccc",
                            justifyContent: "end",
                            gap: "10px",
                            marginTop: "10px",
                        }}
                    >
                        <div style={{display: "flex", gap: "10px", marginRight: "10px"}}>
                            <FullButton
                                buttonText={StringUtils.clearAll}
                                activeColor={
                                    CommonColorUtils.primaryKWhite
                                }
                                inactiveColor={
                                    CommonColorUtils.primaryKWhite
                                }
                                buttonTextColor={
                                    CommonColorUtils.primaryMainBlue
                                }

                                active={
                                    true
                                }
                                height={"48px"}
                                width={"100px"}
                                borderColor={`1px solid ${CommonColorUtils.primaryMainBlue}`}
                                handleOnPress={() => {
                                    setIsFilterOpen(false);
                                    setSelectedFilterCount(0);
                                    setSelectedItems(new Map());
                                    handleClearAll();
                                }}
                            />

                            <FullButton
                                buttonText={StringUtils.submit}
                                activeColor={CommonColorUtils.primaryMainBlue}
                                inactiveColor={CommonColorUtils.primaryMainBlueDisabledColor}
                                buttonTextColor={CommonColorUtils.primaryKWhite}
                                active={true}
                                height={"48px"}
                                width={"100px"}
                                handleOnPress={handleFilterSubmit}
                            />
                        </div>
                    </div>
                </div>


            </Box>
        </div>)}
    </Popper>);
};

export default FmFilterDataComponent;
